import React from 'react';
import { Phone, Mail } from 'lucide-react';
export function CTA() {
  return <section id="contact" className="w-full bg-white" data-id="element-23" data-mp="1lhb99mmhi9pw">
      <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6" data-id="element-24" data-mp="1lgrrc5wu3lbv">
        <div className="overflow-hidden rounded-3xl border border-sky-100 bg-sky-50 px-6 py-14 text-center sm:px-12" data-id="element-25" data-mp="1zh2izb5yx3y3">
          <h2 className="font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-26" data-mp="1uj11guo6xcoq">
            Need a plumber? Let&apos;s get your water flowing.
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg text-slate-600" data-id="element-27" data-mp="11ttrmzjad0o6">
            Call or email for fast, friendly service across Phoenix, Casa Grande, and Tucson.
          </p>

          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-28" data-mp="1brhxolmcduln">
            <a href="tel:5203000690" className="inline-flex items-center justify-center gap-2 rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-slate-800" data-id="element-29" data-mp="1bpeybazaup49">
              <Phone className="h-4 w-4" data-id="element-30" data-mp="33dbuvte51gy3" />
              520-300-0690
            </a>
            <a href="mailto:flowstateplumbers@gmail.com" className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-300 bg-white px-6 py-3 text-sm font-semibold text-slate-800 transition-colors hover:bg-slate-50" data-id="element-31" data-mp="38cy4ztyo6h2o">
              <Mail className="h-4 w-4" data-id="element-32" data-mp="2kfsjij47jm8i" />
              flowstateplumbers@gmail.com
            </a>
          </div>
        </div>
      </div>
    </section>;
}